<template>
    <div class="wrapper">
        <HeaderView />
        <section id="main">
            <router-view />
        </section>
        <notifications />
        <loader />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HeaderView from "./Header.vue";
import Loader from "../views/Loader.vue";

export default defineComponent({
    name: "TemplateView",
    components: {
        HeaderView,
        Loader,
    },
});
</script>

<style></style>
